import { CustomerAndUserIds } from './customer';

export type InteractiveCTAOption = {
  value: string;
  label?: string;
  type: string;
  linkValue?: string;
  isVisible?: boolean;
  title?: string;
};

export type InteractiveCTA = {
  title: string;
  url: string;
  isVisible: boolean;
  type: string;
  linkValue: string;
};
export type CTA = CustomerAndUserIds & {
  id: number;
  ctaSetId: number;
  type: string;
  linkText: string;
  linkValue: string;
  autoOpen: boolean;
  linkPosition: number;
  newWindow: number;
  fileTitle: string;
  fileThumbnail: string;
  itemType: string;
};

export type CTASet = CustomerAndUserIds & {
  id: number;
  company: number;
  title: string;
  defaultLinks: number;
  links: CTA[];
};

export enum CTAButtonsValues {
  START_CONVERSATION = 'start_conversation',
  CONVERSATION = 'conversation',
  EMAIL = 'email',
  VIDEO = 'video',
}
